import React, { useEffect, useRef, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ReactComponent as DownloadIcon } from '../../../src/assets/svg/downloadIcon.svg';
import { apiBaseUrl, searchListingbyName } from '../../util/api';
import classNames from 'classnames';
import axios from 'axios';
import moment from 'moment';
import { languageSelectOptions } from '../../marketplace-custom-config';
import { ReactComponent as JobDtlsIcon } from '../../assets/svg/Icon-feather-eye.svg';
import {
  FieldCustomSelect,
  Form,
  IconSpinner,
  InlineTextButton,
  NamedLink,
} from '..';

import { createInstance, types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AskForStaffButton from '../AskForStaffButton/AskForStaffButton';
import { ReactComponent as Clock } from '../../assets/svg/clock.svg';
import { Form as FinalForm } from 'react-final-form';
import css from './TimeStatement.module.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { withRouter } from 'react-router-dom';
import { propTypes } from '../../util/types';
import { bool, object } from 'prop-types';
import { intlShape } from '../../util/reactIntl';
import { denormalisedResponseEntities } from '../../util/data';
import { adminTimestatmentType } from '../../containers/AdminTimestatementDetailsPage/constant';
import { createSlug } from '../../util/urlHelpers';

import { IoGridOutline } from "react-icons/io5";
import { FaList } from "react-icons/fa";
const { UUID } = sdkTypes;

/**
 *
 * @param {object} options
 * @param {string} options.id
 * @param {string} options.className
 * @param {object[]} options.data
 * @param {object[]} options.headers
 * @param {string} [options.headerText]
 * @param {object} [options.sortConfig]
 * @param {function} [options.sortData]
 * @param {function} [options.viewDetails]
 */

function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    if (!window.matchMedia) return;

    const mediaQueryList = window.matchMedia(query);

    const listener = (event) => {
      setMatches(event.matches);
    };

    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}

const sortDataHandler = (e, key) => {
  if (typeof sortData === 'function') {
    sortData(key);
  }
};
const userUtcOffset = Math.abs(moment().utcOffset());
const isPositiveOffset = moment().utcOffset() > 0;
const formateDate = date => {
  return isPositiveOffset
    ? moment(date)
      .subtract(userUtcOffset, 'm')
      .format('DD/MM/YYYY')
    : moment(date)
      .add(userUtcOffset, 'm')
      .format('DD/MM/YYYY');
};

const formateTime = date => {
  return isPositiveOffset
    ? moment(date)
      .subtract(userUtcOffset, 'm')
      .format('HH:mm')
    :
    moment(date)
      .add(userUtcOffset, 'm')
      .format('HH:mm');
};

const timestatmentTable = options => {
  const {
    data,
    id,
    sortData,
    headers,
    viewDetails,
    sortConfig = {},
    className,
    headerText,
    isDispute
  } = options;
  return (
    <table className={className} id={id}>
      {headerText ? (
        <thead>
          <tr>
            <td>
              <h1>{headerText}</h1>
            </td>
          </tr>
        </thead>
      ) : null}
      {data.length > 0 ? (
        <tbody>
          <tr>
            {headers.map(header => (
              <th
                key={header.key}
                className={css['table-header']}
                onClick={e => sortDataHandler(e, header.key)}
              >
                {header.label}
                {sortConfig.key === header.key ? (
                  <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                ) : null}
              </th>
            ))}
            {typeof viewDetails === 'function' ? <th className={css['table-header']}>&nbsp;</th> : null}
          </tr>
          {data.map((item, index) => (
            <React.Fragment key={index}>
              <tr key={index} className={css['table-row']}>
                {headers.map(header =>
                  header.key === 'startDate' ||
                    header.key === 'endDate' ||
                    header.key === 'paymentDate' ? (
                    <td key={header.key}>
                      {item[header.key] ? formateDate(item[header.key]) : 'NA'}
                    </td>
                  ) : header.key === 'startTime' ? (
                    <td key={header.key}>
                      {item['startDate'] ? formateTime(item['startDate']) : 'NA'}
                    </td>
                  ) : header.key === 'finalWorkingHour' ? (
                    <td key={header.key}>
                      {`${String(Math.floor(item[header.key])).padStart(2, '0')}h${String(
                        Math.round((item[header.key] % 1) * 60)
                      ).padStart(2, '0')}`}
                    </td>
                  ) : header.key === 'finalPayment' || header.key === 'hourlyRate' ? (
                    <td key={header.key}>
                      {'CA$ '}
                      {Number(item.finalPayment).toFixed(2)}
                    </td>
                  ) : (
                    <td key={header.key}>{item[header.key]}</td>
                  )
                )}
                {typeof viewDetails === 'function' ? (
                  <td>
                    <span className={css.ListingCardView}>
                      <a className={css.viewdetails}
                        type="button"
                        onClick={() => viewDetails(item, index)}
                      ><JobDtlsIcon />
                        <FormattedMessage id="Timestatement.viewDetails" /> </a>
                    </span>
                  </td>
                ) : null}
              </tr>
            </React.Fragment>
          ))}
        </tbody>) : (
        <tbody>
          <tr>
            <td>
              <div className={css.noworkerdata}>
                <div className={css.clockIcon}>
                  <Clock />
                </div>
                {<FormattedMessage
                  id={
                    isDispute
                      ? 'Timestatement.noDisputedatafound'
                      : 'Timestatement.nodatafound'
                  }
                />}
              </div>
            </td>
          </tr>
        </tbody>)
      }
    </table>
  );
};

const timestatmentCards = options => {
  const {
    data,
    id,
    sortData,
    headers,
    viewDetails,
    sortConfig = {},
    className,
    headerText,
    isDispute,
    userNativeLang,
    isWorker
  } = options;
  const formatDate = date => {
    return userNativeLang === languageSelectOptions.fr.value
      ? moment(date).format('Do MMM y')
      : moment(date).format('Do MMM, y');
  };
  return <div className={css.cards}> {data.map((item, index) => {
    return (
      <div className={css.mainCardDiv}>
        <div
          className={classNames(css.JobListingCardWrapper, {
            [css.bestMatchesDiv]: '!fromWorkerDashboardForm',
          })}
        >
          <>
            <div className={css.cardTitle}>
              <span>{item.providerName ? item.providerName.toUpperCase() : item.workerName.toUpperCase()}</span>
              <div className={css.dateCardTitle}>
                {item['startDate'] ? formatDate(item.startDate.date) : 'NA'}
              </div>
            </div>
            <div className={css.jobDetailsSubHeadingDiv}>
              <span className={css.gigName}>
                {item.gigName}
              </span>
              <span className={css.payment}>
                {Number(item.finalPayment).toFixed(2)}{' CA$ '}
              </span>
            </div>
            <div className={css.details}>
              <div>
                <span>
                  <FormattedMessage id="FieldDateTimeInput.startTime" /> :
                </span>{" "}
                <span>
                  {item.startDate ? formateTime(item.startDate) : 'NA'}
                </span>
              </div>
              <div>
                <span>
                  <FormattedMessage id="Invoice.totalWorkingHour" /> :
                </span>{" "}
                <span>
                  {`${String(Math.floor(item.finalWorkingHour)).padStart(2, '0')}h${String(
                    Math.round((item.finalWorkingHour) % 1) * 60)
                    .padStart(2, '0')}`}
                </span>
              </div>
              {!isWorker ? <div>
                <span>
                  <FormattedMessage id="Timestatement.dateOfPaymentBusiness" /> :
                </span>{" "}
                <span>
                  {item.paymentDate ? formateDate(item.paymentDate) : 'NA'}
                </span>
              </div> : ""}
            </div>
          </>

          <span className={css.hDivider} />
          <div className={css.footer}>
            {typeof viewDetails === 'function' ? (
              <span className={css.ListingCardView}>
                <a className={css.viewdetails}
                  type="button"
                  onClick={() => viewDetails(item, index)}
                ><JobDtlsIcon />
                  <FormattedMessage id="Timestatement.viewDetails" /> </a>
              </span>
            ) : null}
          </div>
        </div>
      </div>
    );
  })}
  </div>
};

const ToggleButtons = ({ gridDisplay, setGridDisplay }) => {
  const [alignment, setAlignment] = useState(gridDisplay ? 'left' : 'right');

  const handleClick = (value) => {
    setAlignment(value);
    setGridDisplay(value === 'left');
  };

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <button
        onClick={() => handleClick('left')}
        aria-label="left aligned"
        style={{
          padding: '8px 16px',
          backgroundColor: alignment === 'left' ? '#007bff' : '#eee',
          color: alignment === 'left' ? 'white' : 'black',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      ><FaList />
      </button>

      <button
        onClick={() => handleClick('right')}
        aria-label="right aligned"
        style={{
          padding: '8px 16px',
          backgroundColor: alignment === 'right' ? '#007bff' : '#eee',
          color: alignment === 'right' ? 'white' : 'black',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      ><IoGridOutline />
      </button>
    </div>
  );
};

const TimeStatement = props => {
  const { intl, currentUser, history, isDispute, showDisputeOnly, userNativeLang } = props;
  const [reportLoading, setReportLoading] = useState(false);
  const [data, setData] = useState({ data: [], isLoading: false, error: null });
  const formRef = useRef(null);

  const sdkInstance = useRef(createInstance({ clientId: config.sdk.clientId }));

  const currentUserId = currentUser?.id?.uuid;
  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;
  const isSuperAdmin = currentUser?.attributes?.profile?.publicData?.isSuperAdmin;
  const isWorker = !isProvider && !isSuperAdmin;
  const isCurrentUserLoaded = currentUser?.id?.uuid;
  const isMobile = useMediaQuery('(max-width:800px)');

  const [gridDisplay, setGridDisplay] = useState(!isMobile);

  useEffect(() => {
    setGridDisplay(!isMobile);
  }, [isMobile]);

  const [sortConfig, setSortConfig] = useState({ key: 'workerId', direction: 'ascending' });

  const djobIdLabel = intl.formatMessage({ id: 'Timestatement.djobId' });
  const workerIdLabel = isProvider ? intl.formatMessage({ id: 'Timestatement.workerId' }) : '';
  const gigIdLabel = intl.formatMessage({ id: 'Timestatement.gigId' });
  const providerNameLabel = intl.formatMessage({ id: 'Timestatement.providerName' });
  const workerNameLabel = intl.formatMessage({ id: 'Timestatement.workerName' });
  const gigNameLabel = intl.formatMessage({ id: 'Timestatement.gigName' });
  const startDateLabel = intl.formatMessage({ id: 'Timestatement.startDate' });
  const startTimeLabel = intl.formatMessage({ id: 'Timestatement.startTime' });
  const totalWorkingHourLabel = intl.formatMessage({ id: 'Timestatement.totalWorkingHour' });
  const totalPaymentLabel = intl.formatMessage({ id: 'Timestatement.totalPayment' });
  const dateOfPaymentLabel = intl.formatMessage({ id: 'Timestatement.dateOfPaymentBusiness' });

  const timestatementDownloadHeaderLabel = intl.formatMessage({
    id: 'Timestatement.timestatementDownloadHeader',
  });

  const restHeader = [
    { label: gigNameLabel, key: 'gigName' },
    { label: startDateLabel, key: 'startDate' },
    { label: startTimeLabel, key: 'startTime' },
    { label: totalWorkingHourLabel, key: 'finalWorkingHour' },
    { label: totalPaymentLabel, key: 'finalPayment' }
  ];

  const headers = (isWorker)
    ? [{ label: providerNameLabel, key: 'providerName' }, ...restHeader]
    : [{ label: workerNameLabel, key: 'workerName' }, , ...restHeader, { label: dateOfPaymentLabel, key: 'paymentDate' }];

  const sortData = key => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    const newData = [...data.data].sort(compareValues(key, direction));
    setData(data => ({ ...data, data: newData }));
    setSortConfig({ key, direction });
  };

  const compareValues = (key, direction) => {
    return function (a, b) {
      const valueA = a[key];
      const valueB = b[key];

      let comparison = 0;
      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return direction === 'descending' ? comparison * -1 : comparison;
    };
  };

  const viewDetails = data => {
    const pageName = isSuperAdmin
      ? 'AdminTimestatementDetailsPage'
      : isProvider ? 'BusinessDashboardTimeStatementDetailsPage' : 'WorkerTimestatementDetailsPage';

    const params = isWorker ? {
      gigId: data.listingId,
      gigName: encodeURIComponent(data.gigName)
    } :
      {
        workerId: data.workerSharetribeId,
        gigId: data.listingId,
        workerName: data.workerName,
      };

    const queryMaybe = {};
    if (isSuperAdmin && isDispute) {
      queryMaybe.type = adminTimestatmentType.dispute;
    }
    const url = createResourceLocatorString(
      pageName,
      routeConfiguration(),
      params,
      queryMaybe
    );
    history.push(url);
  };

  const fetchUserListing = async (value) => {
    let totalPages = 1,
      page = 1;
    const dataList = [];
    const fetch = async (page) => {
      const resp = await searchListingbyName({
        name: value,
        page,
        ...(isSuperAdmin ? {} : isWorker ? {} : { authorId: currentUserId }),
      });
      const { data, meta } = resp.data;
      totalPages = meta.totalPages;
      const mapData = data.map(d => ({ value: d.id.uuid, label: d.attributes.title }));

      dataList.push(...mapData);
    };
    if (sdkInstance.current) {
      for (; page <= totalPages; page++) {
        await fetch(page);
      }
      return dataList;
    }
    return [];
  };

  const queryTimeStatement = async query => {
    if (data.isLoading) return;
    try {
      setData(data => ({ ...data, isLoading: true, error: null, data: [] }));
      const querymayBe = query ? query : {};
      let page = 1,
        totalPages = 1;
      const url = (isSuperAdmin || isWorker)
        ? `${apiBaseUrl()}/api/timeStatement/get`
        : `${apiBaseUrl()}/api/getTimeStatementsByProviderId/${currentUser.id.uuid}`;
      const timestatements = [];
      if (isSuperAdmin || isWorker) {
        querymayBe.perPage = 100;

        if (isSuperAdmin) {
          querymayBe.isDispute = isDispute;
          querymayBe.showDisputeOnly = showDisputeOnly;
        }

        if (isWorker) {
          querymayBe.workerId = currentUser.id.uuid;
        }
      }
      for (; page <= totalPages; page++) {
        if (isSuperAdmin || isWorker) {
          querymayBe.page = page;
        }
        const resp = await axios.get(url, { params: querymayBe });
        const data = (isSuperAdmin || isWorker) ? resp.data.data : resp.data;
        const meta = (isSuperAdmin || isWorker) ? resp.data.meta : { totalPages: 1 };
        if (isSuperAdmin || isWorker) {
          let listingIds = Array.from(new Set(data.map(d => d.listingId)));
          listingIds = data.map(d =>
            sdkInstance.current.listings.show({ id: new UUID(d.listingId) })
          );
          const listingsResp = await Promise.allSettled(listingIds);
          const listings = listingsResp
            .filter(resp => resp.status === 'fulfilled')
            .map(resp => denormalisedResponseEntities(resp.value)[0])
            .reduce((acc, listing) => {
              acc[listing.id.uuid] = listing;
              return acc;
            }, {});
          data.forEach(d => {
            d.listing = listings[d.listingId];
            d.gigId = d.listing?.attributes?.publicData?.gigId;
          });
        }
        timestatements.push(...data);
        totalPages = meta.totalPages;
        if (isSuperAdmin || isWorker) {
          querymayBe.lastPageId = data[data.length - 1]?._id;
        }
      }
      setData(data => ({ ...data, isLoading: false, data: timestatements }));
    } catch (error) {
      setData(data => ({ ...data, isLoading: false, error }));
    }
  };

  const generateReport = options => {
    const { e, id, pdfLeftPadding = 5, pdfTopPadding = 5, headerText } = options;
    e.preventDefault();
    if (reportLoading) return;
    setReportLoading(true);

    const divElement = document.createElement('div');
    document.body.appendChild(divElement);
    ReactDOM.render(
      <React.Fragment>
        {timestatmentTable({
          data: data.data,
          headers,
          headerText,
          className: css.timeStatementTablePdf,
          id: id,
        })}
      </React.Fragment>,
      divElement
    );
    const element = divElement.querySelector(`#${id}`);
    html2canvas(element, { scale: 8 }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPDF();
      const compWidth = doc.internal.pageSize.getWidth() - 2 * pdfLeftPadding;
      const compHeight = doc.internal.pageSize.getHeight();

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(compWidth / imgWidth, compHeight / imgHeight);
      const imgX = pdfLeftPadding;
      const imgY = pdfTopPadding;

      doc.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      doc.setProperties({
        image_compression: 'NONE',
      });
      doc.save(`Timestatement Report.pdf`);
      document.body.removeChild(divElement);
      setReportLoading(false);
    });
  };

  const handleFormSubmit = useCallback((values) => {
    const queryMayBe = values?.gigName?.value
      ? { listingId: values.gigName.value }
      : undefined;
    return queryTimeStatement(queryMayBe);
  }, [queryTimeStatement]);

  const handleFetchOptions = async value => {
    if (!currentUserId) return [];
    const options = await fetchUserListing(value);
    return options;
  };

  const showContent = () => {
    if (data.isLoading || !isCurrentUserLoaded) {
      return (
        <div className={css.iconWrapper}>
          <IconSpinner className={css.icon} />
        </div>
      );
    } else if (data.error) {
      return (
        <p className={css.error}>
        </p>
      );
    } else {
      return (
        <div className={css.bodyMain}>
          <div className={css.MainTimestatement}>
            <div className={css.timestatementWrap}>
              {gridDisplay ? timestatmentTable({
                data: data.data,
                headers,
                sortConfig,
                sortData,
                viewDetails,
                id: 'timestatement',
                className: css.timeStatementTable,
                isDispute
              }) : timestatmentCards({
                data: data.data,
                headers,
                sortConfig,
                sortData,
                viewDetails,
                id: 'timestatement',
                className: css.timeStatementTable,
                isDispute,
                userNativeLang,
                isWorker
              })}
            </div>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    queryTimeStatement();
  }, [isSuperAdmin, isWorker, isDispute, showDisputeOnly]);

  return (
    <div>
      <div className={css.headingdiv}>
        {!isSuperAdmin && !isWorker && <AskForStaffButton history={history} />}
      </div>
      <div className={css.searchButtons}>
        <FinalForm
          onSubmit={handleFormSubmit}
          intl={intl}
          handleFormSubmit={handleFormSubmit}
          reportLoading={reportLoading}
          render={formRenderProps => {
            const { handleSubmit, intl, form, handleFormSubmit } = formRenderProps;
            const selecteName = 'gigName';
            const handleSelectChange = values => {
              const name = (values && values.value) || '';
              form.change(selecteName, name);
              handleFormSubmit({ [selecteName]: values });
            };

            const handleDownload = e => {
              e.preventDefault();
              generateReport({
                e,
                id: 'pdf_timestatement',
                headerText: timestatementDownloadHeaderLabel,
              });
            };

            return (
              <Form onSubmit={handleSubmit} className={css.searchForm}>
                <FieldCustomSelect
                  options={[]}
                  name={selecteName}
                  placeholder={intl.formatMessage({ id: 'Timestatement.selectGigName' })}
                  className={css.fieldSelectRoot}
                  isSearchable={true}
                  showClearBtn={true}
                  isAsync={true}
                  onChange={handleSelectChange}
                  onFetchOptions={handleFetchOptions}
                />
                {isProvider && !isSuperAdmin && (
                  <InlineTextButton
                    onClick={handleDownload}
                    inProgress={reportLoading}
                    className={css.downloadBtn}
                  >
                    <DownloadIcon />
                    <FormattedMessage id="Timestatement.timestatementDownloadBtn" />
                  </InlineTextButton>
                )}
              </Form>
            );
          }
          }
        />
        <div>{!isMobile ? <ToggleButtons gridDisplay={gridDisplay} setGridDisplay={setGridDisplay} /> : ''}</div>
      </div>
      {showContent()}
    </div>
  );
};

TimeStatement.propTypes = {
  currentUser: propTypes.currentUser,
  isSuperAdmin: bool,
  intl: intlShape,
  history: object,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return { currentUser };
};
export default compose(
  connect(mapStateToProps),
  withRouter,
  injectIntl
)(TimeStatement);

